import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import './index.css';
import App from './App';
import Team from './Team';
import MediaKit from './MediaKit';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import CookiePolicy from './CookiePolicy';
import Culture from './Culture';
import Services from './Services';
import ServiceDetail from './ServiceDetail';
import ChicagoPage from './ChicagoPage';
import ThankYou from './ThankYou';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          {/* Main Pages */}
          <Route path="/" element={<App />} />
          
          {/* Thank You / Conversion Page - For Google Ads Tracking */}
          <Route path="/thank-you" element={<ThankYou />} />
          
          {/* Services Pages - Important for SEO */}
          <Route path="/services" element={<Services />} />
          <Route path="/services/:serviceId" element={<ServiceDetail />} />
          
          {/* Location Pages - Important for Local SEO */}
          <Route path="/chicago" element={<ChicagoPage />} />
          <Route path="/chicago-general-contractor" element={<ChicagoPage />} />
          <Route path="/commercial-construction-chicago" element={<ChicagoPage />} />
          
          {/* About/Company Pages */}
          <Route path="/media-kit" element={<MediaKit />} />
          <Route path="/culture" element={<Culture />} />
          <Route path="/our-team" element={<Team />} />
          
          {/* Legal Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          
          {/* SEO-Friendly Alternate URLs (redirect to main pages) */}
          <Route path="/general-contractor-chicago" element={<ChicagoPage />} />
          <Route path="/construction-company-chicago" element={<ChicagoPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Report Web Vitals - metrics will be logged in development
// and can be sent to analytics in production
reportWebVitals((metric) => {
  // Optional: Handle each metric individually here
  console.log(metric);
});